import workspaceQuery from 'graphql/queries/supplier/SupplierAuditByFieldWorkspaceQuery.graphql';
import fragment from 'graphql/fragments/supplier/SupplierAuditByFieldFragment.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const SupplierAuditByField = {
  type: 'AuditChange',
  formTitle: 'Supplier Audit',
  formUrl: '/Suppliers/SupplierAudit/Form',
  workspace: workspaceQuery,
  fragment,
  workspaceUrl: '/menu/Suppliers',
  screenReference: 'SUPPLIER_AUDIT',
  operations: ALLOW_VIEW,
};

export default SupplierAuditByField;
